<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import SaleService from '@/services/sale'

export default {
  page: {
    title: "Pedido",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Pedido",
      order: {
        cart: {
          customer: {},
          company: {},
          items: []
        }
      },
      cart: {
        items: []
      },
      customerName: '',
      companyName: '',
      products: [],
      loadingProducts: false,

      searchValue: '',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    };
  },
  mounted() {
    const tempOrder = this.$store.getters.orderData;
    this.order = tempOrder;

    if (this.order && this.order.cart) {
      this.customerName = this.order.cart.customer.name;
      this.companyName = this.order.cart.company.name;

      // this.cart = this.order.cart;
    }

    let loader = this.$loading.show();

    SaleService.getCart(this.order.cartId).then((res) => {
      this.order.cart = res.data;
      this.order.cartId = res.data._id;

      this.customerName = this.order.cart.customer.name;
      this.companyName = this.order.cart.company.name;

      this.cart = res.data;

      loader.hide();
    }).catch(() => {
      this.$toast.error('Erro ao carregar os dados do pedido')
      loader.hide();
    })
  },
  methods: {
    add(data) {
      // data.quantity += 1;
      // data.subtotal = data.price * data.quantity;

      // this.calculateCartTotal();

      const oldQuantity = Number(data.quantity);
      let quantity = oldQuantity + 1;

      SaleService.changeQuantity(this.order.cartId, data.productId, quantity).then((res) => {
        this.order.cart = res.data;
        this.cart = res.data;

        this.$store.dispatch('SAVE_ORDER', this.order);
      }).catch((error) => {
        if (error.response.data.code && error.response.data.code === 'E9999') {
          return this.$toast.warning(error.response.data.msg, {
            duration: 10000,
          });
        }

        this.$toast.error('Não foi possível adicionar o item ao carrinho');
        data.quantity = oldQuantity;
      })
    },
    changeQuantity(data) {
      if (data.quantity < 1) return;

      const oldQuantity = Number(data.quantity);
      let quantity = Number(data.quantity);

      if (data.quantity > data.product.stock) {
        quantity = data.product.stock;
      }

      SaleService.changeQuantity(this.order.cartId, data.productId, quantity).then((res) => {
        this.order.cart = res.data;
        this.cart = res.data;

        this.$store.dispatch('SAVE_ORDER', this.order);

        this.$toast.open('Pedido recalculado');
      }).catch((error) => {
        if (error.response.data.code && error.response.data.code === 'E9999') {
          return this.$toast.warning(error.response.data.msg, {
            duration: 10000,
          });
        }

        this.$toast.error('Não foi possível alterar a quantidade do item no carrinho');
        data.quantity = oldQuantity;
      })
    },
    remove(data, removeItem = false) {
      // data.quantity -= 1;
      // data.subtotal = data.price * data.quantity;

      // this.calculateCartTotal();

      if (data.quantity < 1 && !removeItem) return;

      const oldQuantity = Number(data.quantity);
      let quantity = removeItem ? 0 : (oldQuantity - 1);

      if (data.quantity > data.product.stock) {
        quantity = data.product.stock;
      }

      SaleService.changeQuantity(this.order.cartId, data.productId, quantity).then((res) => {
        this.order.cart = res.data;
        this.cart = res.data;

        this.$store.dispatch('SAVE_ORDER', this.order);
      }).catch((error) => {
        if (error.response.data.code && error.response.data.code === 'E9999') {
          return this.$toast.warning(error.response.data.msg, {
            duration: 10000,
          });
        }

        this.$toast.error('Não foi possível adicionar o item ao carrinho');
        data.quantity = oldQuantity;
      })
    },
    calculateCartTotal() {
      const cart = this.cart;

      let total = 0;
      this.cart.items.forEach(item => {
        total += item.subtotal;
      });

      // this.order.cart.total = total;
      cart.total = total;

      this.cart = cart;

      this.$store.state.order.cart = cart;
    },
    openCheckout() {
      if (!this.allowNextStep()) {
        return this.$toast.warning('Carrinho vazio ou sem itens disponíveis');
      }

      this.$router.push('/checkout');
    },
    allowNextStep() {
      if (!this.cart.items || this.cart.items.length === 0) {
        return false;
      }

      const invalidItem = this.cart.items.find(item => {
        return (item.quantity > item.product.stock) || (!item.quantity || item.quantity <= 0) || (item.price <= 0) || (item.unavailable);
      })

      return invalidItem ? false : true;
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <b-card header-class="bg-transparent border-primary" class="border border-primary">
          <div class="row">
            <div class="col-lg-12">
              <p class="card-text mb-0">Cliente selecionado</p>
              <h5 class="card-title">{{customerName}}</h5>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-lg-12">
              <p class="card-text mb-0">Filial selecionada</p>
              <h5 class="card-title">{{companyName}}</h5>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th scope="col">Produto</th>
                    <th scope="col"></th>
                    <th scope="col" class="text-center">Quantidade</th>
                    <th scope="col" class="text-right">Valor Unitário</th>
                    <th scope="col" class="text-right">Valor Produtos</th>
                    <th scope="col" class="text-right">Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in cart.items" :key="data._id" :class="{ 'removed': data.quantity === 0 }">
                    <td>
                      <img
                        :src="data.product.image"
                        alt="product-img"
                        title="product-img"
                        class="avatar-md"
                      />
                    </td>
                    <td>
                      <h5 class="font-size-14">
                        {{data.product.description}}
                      </h5>
                      <p class="mb-0 font-size-12">
                        Código: <span class="font-weight-medium">{{data.product.code}}</span> /
                        Embalagem: <span class="font-weight-medium">{{data.product.unity}}</span> /
                        Cx: <span class="font-weight-medium">{{data.packQuantity}}</span> /
                        Cor: <span class="font-weight-medium">{{data.product.color}}</span> /
                        Estoque: <span class="font-weight-medium mr-2">{{data.product.stock}}</span>
                        <span
                          v-if="data.unavailable"
                          class="badge badge-pill badge-soft-danger font-size-12"
                        >Produto Indisponível</span>
                      </p>
                    </td>
                    <!-- <td class="text-truncate">
                      <span
                        class="badge badge-pill badge-soft-success font-size-12"
                        :class=" { 'badge-soft-danger': !data.available }"
                      >{{data.stockMessage}}</span>
                    </td> -->                          
                    <td class="justify-content-center quantity-group">
                      <div class="btn-group mr-2 mb-2 mb-sm-0">
                        <button type="button" class="btn btn-outline-primary" @click="remove(data)">
                          <i class="fa fa-minus"></i>
                        </button>
                        <input
                          type="tel"
                          :id="data._id"
                          class="form-control input-quantity"
                          v-model="data.quantity"
                          v-mask="'####'"
                          v-on:blur="changeQuantity(data)"
                          :disabled="false"
                        />
                        <button type="button" class="btn btn-outline-primary" @click="add(data)">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>

                      <b-button variant="link" size="sm" @click="remove(data, true)">remover</b-button>

                      <!-- <div class="font-weight-bold font-size-16 text-center">R$ {{data.price}}</div> -->
                    </td>
                    <td class="text-truncate text-right">R$ {{data.price | currency}}</td>
                    <td class="text-truncate text-right">R$ {{data.productsSubtotal | currency}}</td>
                    <td class="font-weight-bold text-truncate text-right">R$ {{data.subtotal | currency}}</td>
                  </tr>

                  <tr>
                    <td colspan="5" class="text-right pb-0">Total Produtos</td>
                    <td class="text-right pb-0">
                      <strong>R$ {{cart.totalProducts | currency}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" class="border-0 text-right pb-0">Total IPI</td>
                    <td class="border-0 text-right pb-0">
                      <strong>R$ {{cart.totalIpi | currency}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" class="border-0 text-right pb-0">Total ST</td>
                    <td class="border-0 text-right pb-0">
                      <strong>R$ {{cart.totalSt | currency}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" class="border-0 text-right pb-0">Total Impostos</td>
                    <td class="border-0 text-right pb-0">
                      <strong>R$ {{cart.totalTaxes | currency}}</strong>
                    </td>
                  </tr>
                  <tr class="mb-0">
                    <td colspan="5" class="border-0 text-right">Total Descontos</td>
                    <td class="border-0 text-right">
                      <strong>- R$ {{cart.totalDiscounts | currency}}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5" class="border-0 text-right">
                      <strong>Total do Pedido</strong>
                    </td>
                    <td class="border-0 text-right text-truncate">
                      <h4 class="m-0">R$ {{cart.total | currency}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-4">
                <router-link
                  tag="a"
                  to="/products"
                >
                  <button type="button" size="lg" class="btn btn-info btn-block btn-outline">
                    <i class="bx bx-left-arrow-alt font-size-16 align-middle mr-2"></i>Continuar Comprando
                  </button>
                </router-link>
              </div>

              <div class="col-4">
              </div>

              <div class="col-4 span-4">
                <button type="button" size="lg" class="btn btn-primary btn-outline btn-block" @click="openCheckout">
                  Prosseguir<i class="bx bx-right-arrow-alt font-size-16 align-middle ml-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss">
  tr.removed {
    color: red;

    p, h5 {
      color: red;
    }
  }

  .search-box form {
    display: flex;
    flex-direction: row;

    .btn {
      margin-left: 10px;
    }
  }

  .btn-link {
    padding-left: 0px;
  }

  .input-quantity {
    max-width: 80px;
    min-width: 40px;
    border-radius: 0px;
    text-align: center;
  }

  tr.in-cart {
    background-color: #f1f1f1;;
  }

  .quantity-group {
    display: flex;
    flex-direction: column;
  }

  // .table td {
  //   border-top: none;
  //   border-bottom: 1px solid #eff2f7;
  // }
</style>